
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Icon from 'components/Icon'

const sizes = {
  small: '8px',
  normal: '12px'
}

export default class Checkbox extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    partialyChecked: PropTypes.bool,
    active: PropTypes.bool,
    color: PropTypes.string,
    align: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    size: PropTypes.oneOf(['small', 'normal']),
    noIcon: PropTypes.bool
  }

  static defaultProps = {
    color: 'transparent',
    size: 'normal',
    align: 'left'
  }

  render() {
    const {checked, size, color, className, id, noIcon, disabled, align, active} = this.props
    const classNames = classnames('checkbox', className, `is-${align}-aligned`, {
      'is-checked': checked,
      'is-disabled': disabled,
      'is-focused': active && !disabled,
      'with-icon': !noIcon
    }, `is-${color}`, `is-size-${size}`)

    if (align === 'right') {
      return (
        <label
          className={classNames}
          onMouseEnter={e => this.onMouseEnter(e)}
          onMouseLeave={e => this.onMouseLeave(e)}
        >
          {this.renderLabel()}
          <span className='checkbox_tick'>
            {this.renderTick()}
          </span>
          <input
            id={id}
            type='checkbox'
            className='checkbox_real'
            checked={checked}
            onBlur={this.props.onBlur}
            onFocus={this.props.onFocus}
            onClick={this.onClick}
            onChange={this.onChange}
          />
        </label>
      )
    }

    return (
      <label
        className={classNames}
        onMouseEnter={e => this.onMouseEnter(e)}
        onMouseLeave={e => this.onMouseLeave(e)}
      >
        <input
          id={id}
          type='checkbox'
          className='checkbox_real'
          checked={checked}
          onBlur={this.props.onBlur}
          onFocus={this.props.onFocus}
          onClick={this.onClick}
          onChange={this.onChange}
        />
        <span className='checkbox_tick'>
          {this.renderTick()}
        </span>
        {this.renderLabel()}
      </label>
    )
  }

  renderTick() {
    const {checked, size, noIcon, partialyChecked} = this.props

    if (!checked) return null

    const tickSize = sizes[size] || sizes.small

    if (noIcon && partialyChecked) return <span className='checkbox_tick-icon-group_partial' />

    return <Icon className='checkbox_tick-icon' name='tick' size={tickSize} />
  }

  renderLabel() {
    const {children} = this.props
    if (!children) return null

    return <span className='checkbox_label'>{children}</span>
  }

  onClick = e => {
    const {onClick, disabled} = this.props
    if (onClick && !disabled) {
      e.stopPropagation()
      e.preventDefault()
      onClick(e)
    }
  }

  onChange = e => {
    const {onChange, disabled} = this.props
    !disabled && onChange && onChange(e.target.checked)
  }

  onMouseEnter(e) {
    const {onMouseEnter, checked, disabled} = this.props
    !disabled && onMouseEnter && onMouseEnter(checked)
  }

  onMouseLeave(e) {
    const {onMouseLeave, checked, disabled} = this.props
    !disabled && onMouseLeave && onMouseLeave(checked)
  }
}



// WEBPACK FOOTER //
// ./client/components/Checkbox/index.js